import Vue from "vue";
import App from "./components/App";
import store from "./store";
import router from "./router";
import vuetify from "./plugins/vuetify";
import utils from "./utils";
import axios from "./configs/axios";
import parse from "./configs/parse";
import imageUploader from "vue-image-upload-resize";
import { logAnalyticsEvent } from "./configs/firebase";
import { logMetrixEvent } from "./configs/metrix";
import {
  verifyIranianNationalId,
  phoneNumberValidator,
} from "@persian-tools/persian-tools";

import "./registerServiceWorker";
import "./configs/components";
import "./configs/sentry";
import "./assets/scss/style.scss";

Vue.prototype.$parseSDK = parse;
Vue.prototype.$axios = axios;
Vue.prototype.$utils = utils;
Vue.prototype.$logAnalyticsEvent = logAnalyticsEvent;
Vue.prototype.$logMetrixEvent = logMetrixEvent;
Vue.prototype.$isNationalCodeValid = verifyIranianNationalId;
Vue.prototype.$isPhoneNumberValid = phoneNumberValidator;

Vue.use(imageUploader);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#root");
